import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Auth
export const login = (email, password) => 
    axios.post(`${API}/auth/login`, { email, password });

export const getMe = () => 
    axios.get(`${API}/auth/me`);

// Users
export const getUsers = () => 
    axios.get(`${API}/users`);

export const createUser = (userData) => 
    axios.post(`${API}/users`, userData);

export const updateUser = (userId, userData) => 
    axios.put(`${API}/users/${userId}`, userData);

export const deleteUser = (userId) => 
    axios.delete(`${API}/users/${userId}`);

// Locations
export const getLocations = () => 
    axios.get(`${API}/locations`);

export const createLocation = (locationData) => 
    axios.post(`${API}/locations`, locationData);

export const updateLocation = (locationId, locationData) => 
    axios.put(`${API}/locations/${locationId}`, locationData);

export const deleteLocation = (locationId) => 
    axios.delete(`${API}/locations/${locationId}`);

// Products (Certificate Products)
export const getProducts = (activeOnly = false) => 
    axios.get(`${API}/products`, { params: { active_only: activeOnly } });

export const getProduct = (productId) => 
    axios.get(`${API}/products/${productId}`);

export const createProduct = (productData) => 
    axios.post(`${API}/products`, productData);

export const updateProduct = (productId, productData) => 
    axios.put(`${API}/products/${productId}`, productData);

export const deleteProduct = (productId) => 
    axios.delete(`${API}/products/${productId}`);

export const generatePrefix = (name) => 
    axios.post(`${API}/products/generate-prefix`, null, { params: { name } });

export const checkPrefix = (prefix) => 
    axios.post(`${API}/products/check-prefix`, null, { params: { prefix } });

// Image Generation
// payload: { prompt: string, style?: string, negative?: string, aspect?: string }
export const generateImage = (payload) => {
    // Back-compat: accept plain string for old callers
    const body = typeof payload === 'string' ? { prompt: payload } : payload;
    return axios.post(`${API}/generate-image`, body);
};

export const improvePrompt = (prompt, style, negative) =>
    axios.post(`${API}/improve-prompt`, { prompt, style, negative });

export const listGallery = () =>
    axios.get(`${API}/image-gallery`);

export const saveToGallery = (payload) =>
    axios.post(`${API}/image-gallery`, payload);

export const deleteFromGallery = (id) =>
    axios.delete(`${API}/image-gallery/${id}`);

// Customers
export const getCustomers = () => 
    axios.get(`${API}/customers`);

export const searchCustomers = (query) => 
    axios.get(`${API}/customers/search?q=${encodeURIComponent(query)}`);

export const createCustomer = (customerData) => 
    axios.post(`${API}/customers`, customerData);

// Sales (Cart-based)
export const getSales = () => 
    axios.get(`${API}/sales`);

export const getSale = (saleId) => 
    axios.get(`${API}/sales/${saleId}`);

export const createSale = (saleData) => 
    axios.post(`${API}/sales`, saleData);

// Certificate lookup
export const getCertificateByFolio = (folio) => 
    axios.get(`${API}/certificates/${folio}`);

// Attendance
export const getAttendance = (date) => 
    axios.get(`${API}/attendance${date ? `?date=${date}` : ''}`);

export const getTodayAttendance = () => 
    axios.get(`${API}/attendance/today`);

export const checkIn = (attendanceData) => 
    axios.post(`${API}/attendance/check-in`, attendanceData);

export const checkOut = (attendanceId) => 
    axios.post(`${API}/attendance/check-out/${attendanceId}`);

// Reports
export const getDashboardStats = () => 
    axios.get(`${API}/reports/dashboard`);

export const getSalesReport = (filters) => 
    axios.post(`${API}/reports/sales`, filters);

// Messaging
export const sendEmail = (to, subject, body) => 
    axios.post(`${API}/send/email`, { to, subject, body });

export const sendSMS = (to, message) => 
    axios.post(`${API}/send/sms`, { to, message });

export const sendWhatsApp = (to, message) => 
    axios.post(`${API}/send/whatsapp`, { to, message });

// Messaging Settings
export const getMessagingSettings = () => 
    axios.get(`${API}/settings/messaging`);

export const testMessaging = (channel, to) => 
    axios.post(`${API}/settings/messaging/test`, null, { params: { channel, to } });

// Seed
export const seedData = () => 
    axios.post(`${API}/seed`);

export default {
    login, getMe,
    getUsers, createUser, updateUser, deleteUser,
    getLocations, createLocation, updateLocation, deleteLocation,
    getProducts, getProduct, createProduct, updateProduct, deleteProduct,
    generatePrefix, checkPrefix, generateImage,
    getCustomers, searchCustomers, createCustomer,
    getSales, getSale, createSale,
    getCertificateByFolio,
    getAttendance, getTodayAttendance, checkIn, checkOut,
    getDashboardStats, getSalesReport,
    sendEmail, sendSMS, sendWhatsApp,
    getMessagingSettings, testMessaging,
    seedData
};
